module.exports = {
	"data": {
		"markdownRemark": {
			"frontmatter": {
				"title": "Shop "
			}
		}
	},
	"pathContext": {
		"path": "/shop"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/shop.json
// module id = ./node_modules/json-loader/index.js!./.cache/json/shop.json
// module chunks = 240543100269747